import React from "react";
import axiosInstance from "../../services/axios";
import { ActionTypes } from "../action-type";


export const checkSubscription = ()=>async(dispatch)=>{
    try{
        const response = await axiosInstance.get("/subscription")
        const {data} = response;
        dispatch({
            type:ActionTypes.SUBSCRIPTION_CHECK,
            payload:data
        })
    }
    catch(err){
        throw(err)
    }
}